import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { selectedAccountInfo } from "store/account/account-selector";
import { defaultPayByTextData } from "./paybytext-state";

export const selectPayByText = (state: RootState) => state.payByText;

export const selectPayByTextByAccount = createSelector(
  [selectPayByText],
  (payByText) => payByText.byAccount,
);

const selectSelectedAccountId = createSelector(
  selectedAccountInfo,
  (accountInfo) => accountInfo?.accountInformationId ?? null,
);

export const selectCurrentPayByText = createSelector(
  [selectPayByTextByAccount, selectSelectedAccountId],
  (byAccount, accountId) =>
    accountId != null
      ? (byAccount[accountId] ?? {
          ...defaultPayByTextData,
          accountInformationId: accountId,
        })
      : null,
);

export const selectPayByTextMeta = createSelector(
  [selectPayByText],
  (payByText) => payByText.meta,
);

export const makeSelectPayByTextForAccount = (accountId?: number) =>
  createSelector(
    [(state: RootState) => state.payByText.byAccount],
    (byAccount) => (accountId != null ? (byAccount[accountId] ?? null) : null),
  );

export const selectIsPaymentMethodUsedInAnyPayByText = (
  paymentMethodId: number,
) =>
  createSelector([selectPayByTextByAccount], (byAccount) => {
    return Object.values(byAccount).some(
      (payByTextData) => payByTextData?.paymentMethodId === paymentMethodId,
    );
  });
